import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";






  @Injectable({providedIn:"root"})

 export class headerInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        const token= localStorage.getItem('token-admin');
        if (token){
        
                req=req.clone({
                    setHeaders: {
                        'Authorization':'Bearer ' + localStorage.getItem('token-admin')
                    }
                })
            
        }

        
        const lang= localStorage.getItem('lang')|| 'en';
        if(lang==="en"){
        req=req.clone({
            setHeaders: {
                'Accept-language':"en"
            }
        })
}else{
    req=req.clone({
        setHeaders: {
            'Accept-language':"ar"
        }
    })
}



        return next.handle(req)
    }


 }









